const discoverData = [
  {
    id: 1,
    cardImg: 'assets/images/nft/group-01.jpg',
    author: "Sibu Bird Watching Community",
    title: "Organizer",
    img: 'assets/images/nft/event-01.jpg',
    likes: "19.29k",
    price: "97.8 ETH",
    category: "World Bird Day",
  },
  {
    id: 2,
    cardImg: 'assets/images/nft/group-02.jpg',
    author: "Sibu Bird Watching Community",
    title: "Organizer",
    img: 'assets/images/nft/event-02.jpg',
    likes: "31.64k",
    price: "475.23 ETH",
    category: "World Migration Bird Day",
    isIcon: true,
  },
  {
    id: 3,
    cardImg: 'assets/images/nft/group-03.jpg',
    author: "Apollo Group",
    title: "Organizer",
    img: 'assets/images/nft/event-03.jpg',
    likes: "8.34k",
    price: "701.38 ETH",
    category: "Bird Watching Trip - Tun Ahmad Zaidi Natural Reserve",
  },
];

export { discoverData };
